import Api from "../../utils/axios";

export const ResourceApi = {
    createResource: (payload) => Api.post("/admin/create-course", payload,{headers:{"Content-Type":"multipart/form-data"}}),
    updateResource: (payload, id) => Api.put(`/admin/update-course/${id}`, payload,{headers:{"Content-Type":"multipart/form-data"}}),
    // getResourceById: (id) => Api.get(`/admin/update-course/${id}`),
    getAllResource: () => Api.post(`/admin/get-all-course`),
    deleteResource: (id) => Api.delete(`admin/delete-course/${id}`)
};